import styled from "styled-components";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const Foot = styled.footer`
  border-top: 1px solid ${({ theme }) => theme.cardBorder};
  padding: 60px 0px 40px;
  text-align: center;
  position: relative;
  z-index: 1;
  background: ${({ $light }) => ($light ? "#fff" : "transparent")};
  color: ${({ $light }) => ($light ? "#111" : "inherit")};
  transition:
    background 0.4s ease,
    color 0.4s ease;
`;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 8px;
  svg {
    height: 28px;
    width: 28px;
  }
  span {
    font-weight: 700;
    letter-spacing: 2px;
    font-size: 0.95rem;

    color: ${({ theme }) => theme.textPrimary};
    font-family: ${({ theme }) => theme.mono};
  }
`;

export const Tagline = styled.p`
  color: ${({ theme }) => theme.textSecondary};
  font-size: 0.8rem;
  margin-bottom: 24px;
  font-style: italic;
`;

export const Links = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  padding: 0 32px;
  @media (max-width: 768px) {
    gap: 12px;
    padding: 0 16px;
  }
`;

export const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.textSecondary};
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.3s;
  &:hover {
    color: ${({ theme }) => theme.accent};
  }
`;

export const PaymentBadge = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  a {
    display: inline-block;
    transition: opacity 0.2s;
    &:hover {
      opacity: 0.8;
    }
  }

  img {
    height: 32px;
    object-fit: contain;
  }
`;

export const SecureNote = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 4px 0 18px;
  padding: 0 24px;
  font-size: 0.7rem;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textSecondary};
  margin-top: -10px;
  svg {
    flex-shrink: 0;
  }
`;

export const LegalLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin: 8px 0 22px;
  flex-wrap: wrap;
  padding: 0 32px;
  font-size: 0.72rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  line-height: normal;

  @media (max-width: 768px) {
    gap: 10px;
    padding: 0 16px;
  }
`;

export const LegalLink = styled(Link)`
  color: ${({ theme }) => theme.textSecondary};
  text-decoration: none;
  transition: color 0.3s;
  &:hover {
    color: ${({ theme }) => theme.accent};
  }
`;

export const Imprint = styled.div`
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
  margin-top: 6px;

  color: ${({ theme }) => theme.textSecondary};
  font-size: 0.75rem;
  opacity: 0.6;
  a {
    color: inherit;
    text-decoration: none;
    transition: color 0.2s ease;
    &:hover {
      color: ${({ theme }) => theme.accent};
    }
  }
`;

export const ImprintRow = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px 14px;
  & + & {
    margin-top: 2px;
  }
`;

export const ImprintBullet = styled.span`
  color: ${({ theme }) => theme.textSecondary};
  opacity: 0.5;
`;

export const Copy = styled.p`
  color: ${({ theme }) => theme.textSecondary};
  font-size: 0.75rem;
  opacity: 0.6;
`;

export const BigTextWrap = styled.div`
  overflow: hidden;
  width: 100%;
  margin: 32px 0;
`;

export const BigText = styled(motion.div)`
  font-size: clamp(100px, 20vw, 220px);
  white-space: nowrap;
  color: ${({ theme }) => theme.accent};
  font-family: ${({ theme }) => theme.mono};
  line-height: 1;
  /* opacity: 0.15; */
  user-select: none;
  will-change: transform;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  svg {
    height: 0.85em;
    width: auto;
    flex-shrink: 0;
    margin-bottom: 25px;
  }
`;
